// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bulk Progress Modal Styles */
.bulk-progress-modal {
  max-width: 600px;
  width: 95vw;
  max-height: 85vh;
  overflow-y: auto;
}

.bulk-progress-modal .modal-body {
  padding: 16px;
  max-height: 60vh;
  overflow-y: auto;
}

.progress-section {
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.progress-header h3 {
  margin: 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.bulk-progress-modal h2 {
  color: #333;
  font-size: 18px;
  margin-bottom: 16px;
  text-align: center;
}

.bulk-progress-modal h3 {
  color: #333 !important;
  font-size: 14px !important;
  font-weight: 600;
  margin-bottom: 8px;
}

.progress-percentage {
  font-weight: bold;
  color: #8e44ad;
  font-size: 18px;
}

.progress-bar {
  width: 100%;
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 6px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #8e44ad 0%, #9b59b6 100%);
  transition: width 0.3s ease;
  border-radius: 3px;
}

.progress-summary {
  margin: 0;
  color: #666;
  font-size: 12px;
  text-align: center;
}

.current-step {
  font-size: 11px;
  color: #856404;
  font-style: italic;
  margin-left: auto;
}

.current-task {
  margin-bottom: 16px;
  padding: 12px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
}

.current-task h3 {
  margin: 0 0 8px 0;
  color: #856404 !important;
  font-size: 12px !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.task-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.task-language,
.task-step {
  display: flex;
  align-items: center;
  gap: 8px;
}

.language-flag,
.step-icon {
  font-size: 16px;
}

.language-name,
.step-name {
  font-weight: 500;
  color: #333;
}

.languages-list {
  margin-bottom: 16px;
}

.languages-list h3 {
  margin: 0 0 8px 0;
  color: #333 !important;
  font-size: 14px !important;
  font-weight: 600;
}

.language-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.language-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  background: white;
  transition: all 0.2s ease;
  font-size: 13px;
}

.language-item.completed {
  background: #d4edda;
  border-color: #c3e6cb;
}

.language-item.current {
  background: #fff3cd;
  border-color: #ffeaa7;
  animation: pulse 2s infinite;
}

.language-item.pending {
  background: #f8f9fa;
  border-color: #dee2e6;
  opacity: 0.7;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
}

.language-status-icon {
  font-size: 16px;
  min-width: 20px;
}

.language-item .language-name {
  flex: 1 1;
  font-weight: 500;
}

.current-step {
  font-size: 12px;
  color: #856404;
  font-style: italic;
}

.stats-section {
  display: flex;
  justify-content: space-around;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  margin-bottom: 16px;
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.stat-label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  font-weight: bold;
  color: #333;
}

.stat-value.status-processing {
  color: #856404;
}

.stat-value.status-completed {
  color: #155724;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.close-button {
  padding: 10px 20px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.close-button:hover:not(:disabled) {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.close-button.completed {
  background: #28a745;
  color: white;
  border-color: #28a745;
}

.close-button.completed:hover {
  background: #218838;
  border-color: #1e7e34;
}

.close-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .bulk-progress-modal {
    width: 98vw;
    max-width: none;
    max-height: 90vh;
  }

  .bulk-progress-modal .modal-body {
    padding: 12px;
    max-height: 70vh;
  }

  .progress-section,
  .current-task,
  .languages-list,
  .stats-section {
    margin-bottom: 12px;
    padding: 10px;
  }

  .task-info {
    gap: 4px;
  }

  .stats-section {
    flex-direction: column;
    gap: 8px;
  }

  .stat {
    flex-direction: row;
    justify-content: space-between;
  }

  .language-item {
    padding: 6px 10px;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BulkProgressModal.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;;;;IAIE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["/* Bulk Progress Modal Styles */\n.bulk-progress-modal {\n  max-width: 600px;\n  width: 95vw;\n  max-height: 85vh;\n  overflow-y: auto;\n}\n\n.bulk-progress-modal .modal-body {\n  padding: 16px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.progress-section {\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.progress-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.progress-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.bulk-progress-modal h2 {\n  color: #333;\n  font-size: 18px;\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.bulk-progress-modal h3 {\n  color: #333 !important;\n  font-size: 14px !important;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.progress-percentage {\n  font-weight: bold;\n  color: #8e44ad;\n  font-size: 18px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 6px;\n  background: #e9ecef;\n  border-radius: 3px;\n  overflow: hidden;\n  margin-bottom: 6px;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #8e44ad 0%, #9b59b6 100%);\n  transition: width 0.3s ease;\n  border-radius: 3px;\n}\n\n.progress-summary {\n  margin: 0;\n  color: #666;\n  font-size: 12px;\n  text-align: center;\n}\n\n.current-step {\n  font-size: 11px;\n  color: #856404;\n  font-style: italic;\n  margin-left: auto;\n}\n\n.current-task {\n  margin-bottom: 16px;\n  padding: 12px;\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 6px;\n}\n\n.current-task h3 {\n  margin: 0 0 8px 0;\n  color: #856404 !important;\n  font-size: 12px !important;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.task-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.task-language,\n.task-step {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.language-flag,\n.step-icon {\n  font-size: 16px;\n}\n\n.language-name,\n.step-name {\n  font-weight: 500;\n  color: #333;\n}\n\n.languages-list {\n  margin-bottom: 16px;\n}\n\n.languages-list h3 {\n  margin: 0 0 8px 0;\n  color: #333 !important;\n  font-size: 14px !important;\n  font-weight: 600;\n}\n\n.language-items {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.language-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  border: 1px solid #e9ecef;\n  background: white;\n  transition: all 0.2s ease;\n  font-size: 13px;\n}\n\n.language-item.completed {\n  background: #d4edda;\n  border-color: #c3e6cb;\n}\n\n.language-item.current {\n  background: #fff3cd;\n  border-color: #ffeaa7;\n  animation: pulse 2s infinite;\n}\n\n.language-item.pending {\n  background: #f8f9fa;\n  border-color: #dee2e6;\n  opacity: 0.7;\n}\n\n@keyframes pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.02); }\n}\n\n.language-status-icon {\n  font-size: 16px;\n  min-width: 20px;\n}\n\n.language-item .language-name {\n  flex: 1;\n  font-weight: 500;\n}\n\n.current-step {\n  font-size: 12px;\n  color: #856404;\n  font-style: italic;\n}\n\n.stats-section {\n  display: flex;\n  justify-content: space-around;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  margin-bottom: 16px;\n}\n\n.stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-value {\n  font-weight: bold;\n  color: #333;\n}\n\n.stat-value.status-processing {\n  color: #856404;\n}\n\n.stat-value.status-completed {\n  color: #155724;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.close-button {\n  padding: 10px 20px;\n  border: 1px solid #ddd;\n  background: white;\n  color: #666;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.close-button:hover:not(:disabled) {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n.close-button.completed {\n  background: #28a745;\n  color: white;\n  border-color: #28a745;\n}\n\n.close-button.completed:hover {\n  background: #218838;\n  border-color: #1e7e34;\n}\n\n.close-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .bulk-progress-modal {\n    width: 98vw;\n    max-width: none;\n    max-height: 90vh;\n  }\n\n  .bulk-progress-modal .modal-body {\n    padding: 12px;\n    max-height: 70vh;\n  }\n\n  .progress-section,\n  .current-task,\n  .languages-list,\n  .stats-section {\n    margin-bottom: 12px;\n    padding: 10px;\n  }\n\n  .task-info {\n    gap: 4px;\n  }\n\n  .stats-section {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .stat {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .language-item {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
